import { StylesIcon } from 'foundations-assets/icons/components/StylesIcon';
import { Button } from 'foundations-components/transitional/components/Button';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { useCallback } from 'react';
import { ToolDropdown } from '../ToolDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
export function ChoiceTool({
  info,
  config,
  onFieldChange
}) {
  var _config$getIcon;
  const {
    field,
    path,
    currentValue
  } = info;
  const Icon = ((_config$getIcon = config.getIcon) === null || _config$getIcon === void 0 ? void 0 : _config$getIcon.call(config, field)) || StylesIcon;
  const label = config.getLabel(field);
  const handleSelect = useCallback(newValue => {
    onFieldChange(path, newValue);
  }, [path, onFieldChange]);
  const choices = field.choices;
  if (!choices || !Array.isArray(choices)) {
    return null;
  }
  return /*#__PURE__*/_jsx(ToolDropdown, {
    Icon: Icon,
    tooltipTitle: label,
    children: /*#__PURE__*/_jsx(List, {
      children: choices.map(([value, choiceLabel]) => /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          size: "small",
          onClick: () => handleSelect(value),
          active: currentValue === value,
          children: choiceLabel
        })
      }, value))
    })
  });
}